interface ClientUpdatedInterface {
    version: String
}

export default defineNuxtPlugin(async (nuxtApp: NuxtApp) => {
    nuxtApp.$socket.on('version_updated', (newData: ClientUpdatedInterface) => {
        const clientVersion = useRuntimeConfig().public.sentry.release;

        useNavigationStore().outdated = newData.version !== clientVersion;
    })
})
